/**
 * Checks whether the current environment is browser or not (Node).
 */
export default typeof window !== "undefined";
